import { OnInit, EventEmitter, ElementRef } from '@angular/core';
var WidgetComponent = /** @class */ (function () {
    function WidgetComponent(element) {
        this.element = element;
        this._open = false;
        this.showActionsOnHover = false;
        this.canToggle = true;
        this.isCompact = false;
        this.opened = new EventEmitter();
    }
    Object.defineProperty(WidgetComponent.prototype, "open", {
        get: function () {
            return this._open;
        },
        set: function (value) {
            this._open = value;
        },
        enumerable: true,
        configurable: true
    });
    WidgetComponent.prototype.ngOnInit = function () {
    };
    WidgetComponent.prototype.handleClickHeader = function () {
        if (!this.canToggle) {
            return;
        }
        this.toggleWidget();
        // Only emit opened event when triggered by user. We do this so the application can react
        // specifically to user input, without interference from programatic changes of the opened
        // state.
        this.opened.emit(this.open);
    };
    WidgetComponent.prototype.toggleWidget = function () {
        if (!this.canToggle) {
            return;
        }
        this.open = !this.open;
    };
    return WidgetComponent;
}());
export { WidgetComponent };
